
export default function PRReportPackageReportController(
  $rootScope,
  ssDialogService,
  alerts,
  confirmDialog,
  reportsDataService,
  loaderService
) {
  const vm = this;

  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;
  vm.handleRemoveReportInstance = _handleRemoveReportInstance;
  vm.handleRemoveArchivedReportInstance = _handleRemoveArchivedReportInstance;

  /** ********************************************
   * Event Handlers
   */
  function _handleRemoveReportInstance($event) {
    ssDialogService.dialogs.reports.deleteReportPackageReportConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Remove Report?',
        message:
          `Are you sure you want to remove "${vm.reportPackageReport.reportInstance.reportName}" from the package?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.reports.deleteReportPackageReportConfirmDialog);
  }

  function _handleRemoveArchivedReportInstance($event) {
    ssDialogService.dialogs.reports.deleteReportPackageReportConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Remove Archived Report?',
        message:
          `Are you sure you want to remove "${vm.reportPackageReport.reportInstanceArchive.reportName}" from the package?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.reports.deleteReportPackageReportConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return reportsDataService.deleteReportPackageReport(vm.reportPackageReport.reportPackageReportInstanceId)
      .then(() => {
        alerts.success('The report has been successfully removed from the Package.');
        $rootScope.$broadcast('reports.reportPackageReportDeleted', { reportPackageReport: vm.reportPackageReport });
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('An error occurred while deleting the schedule.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  /** ********************************************
   * Private Functions
   */

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.reports.deleteReportPackageReportConfirmDialog);
  }
}

PRReportPackageReportController.$inject = [
  '$rootScope',
  'ssDialogService',
  'alerts',
  'confirmDialog',
  'reportsDataService',
  'loaderService'
];
